<div class="container-fluid">
  <div class="d-flex flex-lg-row flex-md-column flex-sm-column flex-column gap-4"
    *ngIf="currentUserMode === 'customer'">
    <div class="col-lg-8 col-md-12">
      <div class="d-flex flex-column h-100">

        <div class="d-flex flex-row pb-3 col-12">
          <div class="card p-3 border-1 rounded-2 dashboard-card-secondary w-100">
            <div class="card-title fw-bold fs-4">
              Ready to ship
            </div>
            <div class="card-body px-0">
              Create a listing and/or invite providers to quote on it.
            </div>
            <div class="d-grid col-lg-6 col-md-12 col-sm-12 col-12">
              <button class="btn btn-secondary text-white" (click)="redirectTo('/instant-quote')">Create a
                listing</button>
            </div>
          </div>
        </div>

        <div class="d-flex flex-wrap flex-row pb-3 col-12">
          <div class="col-sm-6 col-md-6 col-lg-4 col-12" *ngFor="let card of keyValues"
            (click)="redirectToShipments(card)">
            <div class="card m-2 py-3 text-center 2-100" style="cursor: pointer;">
              <div class="card-title fw-bold fs-6 text-capitalize text-muted">
                {{card.title}}
              </div>
              <div class="card-body fs-3 fw-bolder px-0 pt-0 read-on">
                {{card.value}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-4 col-md-12" style="height: 300px !important;">
      <div class="card p-3 border-1 rounded-2 w-100">
        <div class="card-title fs-5 fw-bold">
          Got complex freight?
        </div>
        <div class="card-body mx-0">
          Speak to one of our account managers to settle your shipping problems.
        </div>
        <div class="d-grid col-12">
          <button class="btn btn-secondary text-white" (click)="this.getHelp()">
            Talk to an expert
          </button>
        </div>
      </div>
    </div>
  </div>


  <div class="d-flex flex-md-column gap-4" *ngIf="currentUserMode === 'provider'">
    <div class="fs-2">Dashboard</div>

    <div class="d-flex flex-row gap-1 fw-semibold">
      Profile Completeness:
      <span [ngClass]="{
      'text-danger': overview?.completion_rate < 50,
      'text-warning': overview?.completion_rate >= 50 && overview?.completion_rate < 80,
      'text-success': overview?.completion_rate >= 80
    }">
        {{ overview?.completion_rate ?? '-' }} %
      </span>

      <i class="bi" [ngClass]="{
      'bi-x-circle-fill text-danger': overview?.completion_rate < 50,
      'bi-exclamation-circle-fill text-warning': overview?.completion_rate >= 50 && overview?.completion_rate < 80,
      'bi-check-circle-fill text-success': overview?.completion_rate >= 80
    }"></i>
    </div>

    <!-- Summary Section -->
    <div class="container-fluid p-0 mb-4">
      <div class="text-secondary fw-semibold fs-5 mb-2">Summary</div>
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-3">
        <div class="col">
          <div class="border rounded p-3 d-flex flex-row align-items-center gap-2 bg-white">
            <div class="d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
              <img src="assets/icons/dashboard-wallet.svg" alt="image">
            </div>
            <div class="d-flex flex-column text-start">
              <h6 class="mb-1 fw-bold">{{ overview?.wallet ?? '-' }}</h6>
              <p class="mb-0 text-muted small">Wallet Balance(AUD)</p>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="border rounded p-3 d-flex flex-row align-items-center gap-2 bg-white">
            <div class="d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
              <img src="assets/icons/dashboard-calendar.svg" alt="image">
            </div>
            <div class="d-flex flex-column text-start">
              <h6 class="mb-1 fw-bold">{{ overview?.booked_jobs ?? '-' }}</h6>
              <p class="mb-0 text-muted small">Booked Jobs</p>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="border rounded p-3 d-flex flex-row align-items-center gap-2 bg-white">
            <div class="d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
              <img src="assets/icons/dashboard-clock.svg" alt="image">
            </div>
            <div class="d-flex flex-column text-start">
              <h6 class="mb-1 fw-bold">{{ overview?.jobs_started ?? '-' }}</h6>
              <p class="mb-0 text-muted small">Jobs Started</p>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="border rounded p-3 d-flex flex-row align-items-center gap-2 bg-white">
            <div class="d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
              <img src="assets/icons/dashboard-truck.svg" alt="image">
            </div>
            <div class="d-flex flex-column text-start">
              <h6 class="mb-1 fw-bold">{{ overview?.job_in_transit ?? '-' }}</h6>
              <p class="mb-0 text-muted small">Jobs in Transit</p>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="border rounded p-3 d-flex flex-row align-items-center gap-2 bg-white">
            <div class="d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
              <img src="assets/icons/dashboard-box.svg" alt="image">
            </div>
            <div class="d-flex flex-column text-start">
              <h6 class="mb-1 fw-bold">{{ overview?.jobs_completed ?? '-' }}</h6>
              <p class="mb-0 text-muted small">Jobs Completed</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Section -->
    <div class="container-fluid p-0 mb-4">
      <div class="text-secondary fw-semibold fs-5 mb-2">Actions</div>
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-3">

        <div class="col">
          <a href="#" (click)="redirectToInvitation()" target="_blank" class="text-decoration-none">
            <div class="border rounded p-3 d-flex flex-row align-items-center gap-2 bg-white">
              <div class="d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
                <img src="assets/icons/dashboard-envelop.svg" alt="image">
              </div>
              <div class="d-flex flex-column text-start">
                <h6 class="mb-1 fw-bold">{{ overview?.job_invitations ?? '-' }}</h6>
                <p class="mb-0 text-muted small">Job Invitation</p>
              </div>
            </div>
          </a>
        </div>
        <div class="col">
          <a href="#" (click)="redirectToPendingJobs()" target="_blank" class="text-decoration-none">
            <div class="border rounded p-3 d-flex flex-row align-items-center gap-2 bg-white">
              <div class="d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
                <img src="assets/icons/dashboard-stop-sign.svg" alt="image">
              </div>
              <div class="d-flex flex-column text-start">
                <h6 class="mb-1 fw-bold">{{ overview?.pending_cancelation ?? '-' }}</h6>
                <p class="mb-0 text-muted small">Pending Cancellations</p>
              </div>
            </div>
          </a>
        </div>
        <div class="col">
          <div class="border rounded p-3 d-flex flex-row align-items-center gap-2 bg-white"
            (click)="openDisputesModal()" style="cursor: pointer;">
            <div class="d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
              <img src="assets/icons/dashboard-exclamation.svg" alt="image">
            </div>
            <div class="d-flex flex-column text-start">
              <h6 class="mb-1 fw-bold">{{ overview?.disputes?.length ?? '-' }}</h6>
              <p class="mb-0 text-muted small">Disputes</p>
            </div>
          </div>
          <ng-template #disputesModal let-modal>
            <div class="modal-header">
              <h5 class="modal-title">Disputes</h5>
              <button type="button" class="btn-close" aria-label="Close"
                (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body" style="max-height: 60vh; overflow-y: auto;">
              <!-- Bootstrap Table -->
              <table class="table table-bordered table-hover table-sm align-middle">
                <thead class="table-light">
                  <tr>
                    <th>Dispute #</th>
                    <th>Listing ID</th>
                    <th>Comment Initiator</th>
                    <th>Comment Responder</th>
                    <th>Initiated By</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dispute of overview?.disputes; let i = index">
                    <td>{{ dispute.dispute_id }}</td>
                    <td>
                      <a [href]="domain + '/listing/' + dispute?.listing_entity.category_url_key + '/' + dispute?.listing_id"
                        target="_blank">
                        {{ dispute?.listing_id }}
                      </a>
                    </td>
                    <td>{{ dispute?.comment_initiator }}</td>

                    <td>{{ dispute?.comment_responder }}</td>
                    <td>{{ dispute?.raised_by }}</td>
                    <td><span class="badge bg-danger">{{ dispute.status }}</span></td>

                    <td>{{ formatDate(dispute.created_at) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary text-white" (click)="modal.close()">Close</button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
